/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Link } from 'react-router';
import { orderBy, filter } from 'lodash';
import moment from 'moment-timezone';
import { Tooltip } from '@material-ui/core';
import classNames from 'classnames';
import { simpleNotification } from '../../../../utils/notifications';
import './TwitchDrop.scss';

const quickWidth = {};

class TwitchDrop extends React.Component {
  constructor(props) {
    super(props);
    this.idCopy = React.createRef();
    this.props = props;
    this.state = {
      copyModal: false,
      questCopyId: null,
      selectGame: null,
      tab: 1,
    };
  }

  UNSAFE_componentWillMount() {
    const { token } = this.props.auth;
    const { gameId } = this.props.router.params;
    localStorage.setItem('questsPathname', this.props.router.location.pathname);
    this.setState({ selectGame: gameId });
    if (!this.props.commandCenter.twitchDrops.isLoading) {
      this.props.getAdminTwitchDropListByGame(gameId, token);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (localStorage.getItem('questsPathname') !== nextProps.router.location.pathname) {
      localStorage.setItem('questsPathname', nextProps.router.location.pathname);
      const { token } = this.props.auth;
      const { gameId } = this.props.router.params;
      this.setState({ selectGame: gameId });
      if (!this.props.commandCenter.twitchDrops.isLoading) {
        this.props.getAdminTwitchDropListByGame(gameId, token);
      }
    }
    if (this.props.commandCenter.twitchDrop.isCopying === true && nextProps.commandCenter.twitchDrop.isCopying === false ) {
      if (nextProps.commandCenter.twitchDrop.errors.hasError) {
          simpleNotification({
            level: 'error',
            title: 'Copy Twitch Drop failure.',
            message: nextProps.commandCenter.twitchDrop.errors.message,
          });
      } else {
        simpleNotification({
          level: 'success',
          title: 'Twitch Drop Copy Successful.',
          message: 'Your twitch drop has been copyed successfully.',
        });
        const { token } = this.props.auth;
        const { gameId } = this.props.router.params;
        this.props.getAdminTwitchDropListByGame(gameId, token);
      }
    }
    if (this.props.commandCenter.twitchDrop.isDeleting === true && nextProps.commandCenter.twitchDrop.isDeleting === false ) {
      if (nextProps.commandCenter.twitchDrop.errors.hasError) {
        simpleNotification({
          level: 'error',
          title: 'Delete Twitch Drop failure.',
          message: nextProps.commandCenter.twitchDrop.errors.message,
        });
      } else {
        simpleNotification({
          level: 'success',
          title: 'Twitch Drop Delete Successful.',
          message: 'Your twitch drop has been deleted successfully.',
        });
        const { token } = this.props.auth;
        const { gameId } = this.props.router.params;
        this.props.getAdminTwitchDropListByGame(gameId, token);
      }
    }
  }

  copyText = (event) => {
    const text = event.target.innerHTML;
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(text);
      simpleNotification({
        level: 'success',
        title: 'Successfully Copied',
        message: `${text}`,
        autoDismiss: 2,
      });
    }
  }

  generateRowsHTML = (quests, gameId) => {
    // const today = moment().tz('America/Los_Angeles');
    // const hoursOffset = -today.utcOffset() / 60;
    const userTimezone = moment.tz.guess();
    console.log('用户当前时区:', userTimezone); // 便于调试

    if (quests.length >= 1) {
      return quests.map((quest, index) => (
        <div className="row" key={quest.id}>
          <div className="table-cell">{quest.title}</div>
          <div
            className="table-cell"
            ref={this.idCopy}
            style={{ cursor: 'pointer', ...quickWidth }}
            onClick={e => this.copyText(e)}
            aria-hidden
          >
            {quest.id}
          </div>
          {/* <div className="table-cell">{quest.startDateTime ? moment(quest.startDateTime).tz('America/Los_Angeles').add(hoursOffset, 'hours').format('MM-DD-YY hh:mm A') : '-'}</div>
          <div className="table-cell">{quest.endDateTime ? moment(quest.endDateTime).tz('America/Los_Angeles').add(hoursOffset, 'hours').format('MM-DD-YY hh:mm A') : '-'}</div> */}
          <div className="table-cell">
            {quest.startDateTime
              ? moment.utc(quest.startDateTime).tz(userTimezone).format('MM-DD-YY hh:mm A')
              : '-'}
          </div>
          <div className="table-cell">
            {quest.endDateTime
              ? moment.utc(quest.endDateTime).tz(userTimezone).format('MM-DD-YY hh:mm A')
              : '-'}
          </div>
          <div className="table-cell">
            {(quest.slug)
              &&
              <Link
                to={`/twitch-drop/${quest.slug}`}
                activeClassName="active"
                href={`/twitch-drop/${quest.slug}`}
                className="remove-key"
                target="_blank"
              >
                <i className="fa fa-external-link" />
              </Link>}
            {!(quest.slug)
              &&
              <span className="not-available">
                Not Available
              </span>
            }
          </div>
          <div className="table-cell">
            <Tooltip title="Edit" placement="top">
              <Link
                to={`/admin/command-center/${gameId}/twitch-drop/${quest.id}/edit`}
                activeClassName="active"
                href={`/admin/command-center/${gameId}/twitch-drop/${quest.id}/edit`}
                className="remove-key"
              >
                <i className="fa fa-pencil" />
              </Link>
            </Tooltip>
            {moment(quest.startDateTime).diff(moment(Date.now())) > 0 &&
              <Tooltip title="Delete" placement="top">
                <button className="remove-key" onClick={() => { this.deleteTwitchDrop(quest, index); }}>
                  <i className="fa fa-trash" />
                </button>
              </Tooltip>
            }
            <Tooltip title="Duplicate" placement="top">
              <button className="remove-key" onClick={() => { this.setState({ copyModal: true, questCopyId: quest.id, selectGame: gameId }); }}>
                <i className="fa fa-copy" />
              </button>
            </Tooltip>
          </div>
        </div>
      ));
    }
    return (<div className="NoTwitchDrop">No TwitchDrop for this game</div>);
  }

  deleteTwitchDrop(quest, index) {
    if (window.confirm('This will delete the selected Twitch Drop, proceed?')) {
      const { token } = this.props.auth;
      this.props.deleteTwitchDrop(quest?.id, token);
    }
  }

  copyCCTwitchDrop() {
    if (window.confirm('Are you sure about copy this Twitch Drop?')) {
      const { token } = this.props.auth;
      this.props.copyCCTwitchDrop(this.state.questCopyId, this.state.selectGame, token);
      //localStorage.setItem('questsPathname', 'copyCCTwitchDrop');
      this.setState({ copyModal: false });
    }
  }

  closeCopyModal = () => {
    this.setState({
      copyModal: false,
    });
  }

  renderCopyModal() {
    const { data: games } = this.props.commandCenter.games;
    // const { gameId } = this.props.router.params;
    let configGames = games.map(game => ({
      value: game.id,
      label: game.name,
    }));
    configGames = orderBy(configGames, ['label'], ['asc']);
    const renderSelectOptions = option => (<option key={option.value} value={option.value}>{option.label}</option>);
    return (
      <section className="ModalMaster active">
        <section className="Modal active">
          <button onClick={this.closeCopyModal.bind(this)} className="Modal__layer" aria-hidden />
          <section className="Modal__wrapper Copy">
            <div className="Modal__copy__header">
              Select the game
            </div>
            <div className="Modal__copy__body">
              <select
                onChange={event => this.setState({ selectGame: event.target.value })}
                className=""
                value={this.state.selectGame}
              >
                {configGames.map(renderSelectOptions)}
              </select>
            </div>
            <div className="Modal__copy__footer">
              <button
                onClick={this.closeCopyModal.bind(this)}
              >
                <i className="fa fa-times" /> Cancel
              </button>
              <button
                onClick={this.copyCCTwitchDrop.bind(this)}
              >
                <i className="fa fa-check" /> Copy
              </button>
            </div>
          </section>
        </section>
      </section>
    );
  }

  render() {
    const { gameId } = this.props.router.params;
    const { data: quests, isLoading } = this.props.commandCenter.twitchDrops;
    const { tab } = this.state;

    if (isLoading) {
      return (<i className="fa fa-spinner fa-spin fa-3x fa-fw" />);
    }

    // 使用本地时区处理
    const userTimezone = moment.tz.guess();
    const today = moment();

    // 使用本地时区判断任务是否活跃
    let activeQuests = filter(quests, x => (
      moment.utc(x.endDateTime).tz(userTimezone) > today
    ));
    let finishedQuests = filter(quests, x => (
      moment.utc(x.endDateTime).tz(userTimezone) <= today
    ));

    activeQuests = orderBy(activeQuests, ['endDateTime'], ['desc']);
    finishedQuests = orderBy(finishedQuests, ['endDateTime'], ['desc']);

    let showQuests = [];

    if (tab === 1) {
      showQuests = [...activeQuests];
    } else if (tab === 2) {
      showQuests = [...finishedQuests];
    }



    return (
      <section className="CCTwitchDrop">
        <Link
          to={`/admin/command-center/${gameId}/twitch-drop/create`}
          activeClassName="active"
          href={`/admin/command-center/${gameId}/twitch-drop/create`}
        >
          <button className="CCTwitchDrop__create--btn CTAButton__purple">
            Create Twitch Drop
          </button>
        </Link>
        <div className="Global__tabs">
          <div className={classNames('Global__tab', { active: tab === 1 })} onClick={() => this.setState({ tab: 1 })} aria-hidden>
            Active ({activeQuests.length})
          </div>
          <div className={classNames('Global__tab', { active: tab === 2 })} onClick={() => this.setState({ tab: 2 })} aria-hidden>
            Finished ({finishedQuests.length})
          </div>
        </div>
        <section className="ToggleTable">
          <section className="ToggleTable__table-wrapper">
            <section className="ToggleTable__table flex-table">
              <div className="row">
                <div className="table-cell headline">Title</div>
                <div className="table-cell headline" style={quickWidth}>Twitch Drop ID</div>
                <div className="table-cell headline">Start Date</div>
                <div className="table-cell headline">End Date</div>
                <div className="table-cell headline">Landing Page</div>
                <div className="table-cell headline">Actions</div>
              </div>
              {this.generateRowsHTML(showQuests, gameId)}
            </section>
          </section>
        </section>
        {(this.state.copyModal) && this.renderCopyModal()}
      </section>
    );
  }
}

TwitchDrop.propTypes = {

};

export default TwitchDrop;
